export default "__VITE_ASSET__QeAMOXrD__"